<template>
  <NavigationOnlyLayout>
    <!--
      NavigationOnly's container clips rather than scrolls, so the BOQ gets a region of its own:
      the seam its custom scrolling replaces (PLE-1778). Until then it scrolls the way
      `#layout-container` does under DefaultLayout, so nothing reachable today is cut off.
    -->
    <div ref="scrollRegionRef" class="flex min-h-0 flex-1 flex-col overflow-y-auto">
      <slot />
    </div>
  </NavigationOnlyLayout>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import NavigationOnlyLayout from '@/layouts/NavigationOnlyLayout.vue';

const route = useRoute();
const scrollRegionRef = ref<HTMLElement | null>(null);

// The router's `scrollBehavior` only resets `#layout-container`, which no longer scrolls here, so
// switching BOQ tabs would otherwise open the next tab part-way down.
watch(
  () => route.path,
  () => {
    if (scrollRegionRef.value) scrollRegionRef.value.scrollTop = 0;
  },
);
</script>
